var _path;

function _extends() { _extends = Object.assign || function (target) { for (var i = 1; i < arguments.length; i++) { var source = arguments[i]; for (var key in source) { if (Object.prototype.hasOwnProperty.call(source, key)) { target[key] = source[key]; } } } return target; }; return _extends.apply(this, arguments); }

import * as React from "react";

function SvgSettingsIcon(_ref, svgRef) {
  let {
    title,
    titleId,
    ...props
  } = _ref;
  return /*#__PURE__*/React.createElement("svg", _extends({
    xmlns: "http://www.w3.org/2000/svg",
    width: 17.411,
    height: 16.855,
    viewBox: "0 0 17.411 16.855",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _path || (_path = /*#__PURE__*/React.createElement("path", {
    id: "Settings_Icon",
    "data-name": "Settings Icon",
    d: "M279.348,55.1l1.52-2.395.9-.73.172.173,3.021-3.023.752.742-3.026,3.026.173.175-.728.9-2.4,1.52Zm12.976-.151-8.65-8.65-.012-.012a3.713,3.713,0,0,1-4.739-4.5l2.1,2.1,2.062-.552.552-2.058-2.1-2.1a3.709,3.709,0,0,1,4.546,4.583L294.8,52.47a1.753,1.753,0,1,1-2.478,2.479Zm.724-.964a.668.668,0,1,0,.666-.669A.668.668,0,0,0,293.047,53.986Zm-4.575-9.373a1.8,1.8,0,0,0,.31-1.221l4.758-4.758L296.2,41.3l-4.757,4.758a1.807,1.807,0,0,0-1.206.3Z",
    transform: "translate(-278.792 -38.633)",
    fill: "#b1b1b1"
  })));
}

const ForwardRef = /*#__PURE__*/React.forwardRef(SvgSettingsIcon);
export default __webpack_public_path__ + "static/media/settings-icon.251b862e.svg";
export { ForwardRef as ReactComponent };